import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import { LocalePicker } from "@temp/@next/components/molecules";
import { usePreferences } from "@temp/@next/hooks";
import { usePrismicLayout } from "@temp/@prismic/templates/PrismicLayout/hooks/usePrismicLayout";
import classNames from "classnames";
import React, { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import Media from "react-media";
import { OverlayTheme, OverlayType } from "..";
import { mediumScreen } from "../../globalStyles/scss/variables.scss";
import { RegionPicker } from "../RegionsPicker";
import { FLAGS_DICTIONARY } from "./FlagsDictonary";
export function LocaleDropdown(_ref) {
  var overlay = _ref.overlay;
  var intl = useIntl();

  var _usePrismicLayout = usePrismicLayout(),
      layout = _usePrismicLayout.layout;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var showOverlayHandler = useCallback(function () {
    var show = overlay.show;
    setActive(true);
    show(OverlayType.mainMenuNav, OverlayTheme.modal);
  }, [overlay]);
  var hideOverlayHandler = useCallback(function () {
    var hide = overlay.hide;

    if (active) {
      hide();
      setActive(false);
    }
  }, [active, overlay]);

  var _usePreferences = usePreferences(),
      locale = _usePreferences.preferences.locale;

  return React.createElement(Media, {
    query: {
      minWidth: mediumScreen
    }
  }, function (matches) {
    return matches ? React.createElement("ul", {
      className: classNames({
        "main-menu__nav-dropdown": true,
        "main-menu__nav-dropdown--active": active
      }),
      onMouseOver: showOverlayHandler,
      onMouseLeave: hideOverlayHandler,
      onFocus: showOverlayHandler,
      onBlur: hideOverlayHandler
    }, React.createElement("li", {
      className: "main-menu__item main-menu__item-lang-select"
    }, React.createElement("div", {
      className: "main-menu__nav-link"
    }, React.createElement("img", {
      src: FLAGS_DICTIONARY[locale],
      alt: ""
    }))), React.createElement("li", {
      className: classNames({
        "main-menu__nav-dropdown__body": true,
        "main-menu__nav-dropdown__body--visible": active,
        "no-padding": true
      })
    }, React.createElement("div", {
      className: "locales"
    }, React.createElement("div", {
      className: "locales__regions"
    }, React.createElement("div", {
      className: "locales__item-top"
    }, React.createElement("h5", {
      className: "locales__item-title"
    }, layout === null || layout === void 0 ? void 0 : layout.region_title), React.createElement("p", {
      className: "locales__item-subtitle"
    }, layout === null || layout === void 0 ? void 0 : layout.region_description)), React.createElement(RegionPicker, null)), React.createElement("div", {
      className: "locales__languages"
    }, React.createElement("div", {
      className: "locales__item-top"
    }, React.createElement("h5", {
      className: "locales__item-title"
    }, intl.formatMessage(_defineProperty({
      defaultMessage: "Language",
      "id": "components.MainMenu.LocaleDropdown.604081953"
    }, "id", "components.MainMenu.LocaleDropdown.604081953")))), React.createElement(LocalePicker, {
      onPicked: hideOverlayHandler
    }))))) : null;
  });
}